module.exports = __webpack_public_path__ + "static/unilasalle_lrv_logo-6c300ed9873e87ab25d30e4b8ab3d30f.png";